<template>
  <div class="container p-0 mt-2" v-show="!hidden">
    <div class="row" role="radiogroup" :aria-labelledby="ids.label" :aria-describedby="describedBy">
      <div class="col-10">
        <div v-for="(option,index) in radioButtonOptions" :key="index" class="form-check form-check-inline">
          <!-- De optie-id's waren per componentinstantie genummerd vanaf 0, dus
               twee radiovelden op één pagina kregen dezelfde id's. -->
          <input @change="radioButtonChanged()" class="form-check-input" type="radio" :required="element.required"
            :name="'radio'+element.name" :id="ids.option(index)" :value="option.value" v-model="elData.value"
            :disabled="hidden">
          <!-- form-radio-label bestaat niet in Bootstrap; het label kreeg daardoor geen opmaak. -->
          <label class="form-check-label" :for="ids.option(index)">{{getTextFor(option.text,lang)}}</label>
          <div v-if="isLoading" class="input-group-append">
            <span class="input-group-text">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Laden...</span>
              </div>
            </span>
          </div>
        </div>
        <div class="invalid-feedback" :id="ids.error" :style="invalidStyle">{{ getTextFor(element.invalid,lang) }}</div>
        <div v-if="heeftUitleg" :id="ids.help" class="form-text">{{ getTextFor(element.explanation, lang) }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import FormSubmitService from '../../services/FormSubmitService'
import veldToegankelijkheid from '../../utils/veldToegankelijkheid'
export default {
  mixins: [veldToegankelijkheid],
  name: 'FormElementRadioButton',
  props: ['element', 'lang', 'targetId', 'formData', 'wasValidated', 'hidden'],
  emits: ['elementChanged'],
  data() {
    return {
      elData: {value:null},
      radioButtonOptions: [] as Array<{text: {[key: string]: string}, value: string}>,
      isLoading: false,
      formSubmitService: new FormSubmitService()
    }
  },
  methods: {
    /**
     * Eigen beoordeling: een radiogroep is geldig zodra er één optie gekozen is.
     * De mixin zoekt een control met checkValidity(), en die is er hier niet
     * voor de groep als geheel.
     */
    herbeoordeel() {
      if (!this.ooitGevalideerd) { this.ongeldig = false; return; }
      this.ongeldig = !!this.element.required && (this.elData.value === null || this.elData.value === undefined);
    },
    radioButtonChanged(){
      this.herbeoordeel();
      let processedValue = this.elData.value;
      
      // Behandel booleaanse waarden
      if (processedValue === 'true') {
        processedValue = true;
      } else if (processedValue === 'false') {
        processedValue = false;
      } else if (!isNaN(Number(processedValue)) && processedValue !== '') {
        // Converteer numerieke strings naar echte getallen
        processedValue = Number(processedValue);
      }
      
      this.$emit('elementChanged', this.element.name, processedValue)
    },
    getTextFor(data: {[key: string]: string}, lang: string) {
      return data ? data[lang] : '';
    },
    async loadOptions() {
      if(this.element.relationConfig && this.element.relationConfig.enabled) {
        this.isLoading = true;
        try {
          const { collectionPath, labelField, valueField, formConfigPath } = this.element.relationConfig;
          const relatedRecords = await this.formSubmitService.getRelatedRecords(
            collectionPath,
            labelField,
            valueField || 'id',
            formConfigPath
          );
          this.radioButtonOptions = relatedRecords;
        } catch (error) {
          console.error('Fout bij het ophalen van gerelateerde records:', error);
          this.radioButtonOptions = this.element.options || [];
        } finally {
          this.isLoading = false;
        }
      } else {
        this.radioButtonOptions = this.element.options || [];
      }
    }
  },
  created() {
    if(this.formData[this.element.name]){
      this.elData.value = this.formData[this.element.name]
    }
    this.loadOptions();
  }
}
</script>

